/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MandatsreferenzInputs */

const de__field_mandatsreferenz = /** @type {(inputs: _Field_MandatsreferenzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandatsreferenz`)
};

/**

* @param {_Field_MandatsreferenzInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_mandatsreferenz = /** @type {((inputs?: _Field_MandatsreferenzInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MandatsreferenzInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_mandatsreferenz(inputs)
});